module.exports = __webpack_public_path__ + "images/application/logo-ac-sign-a9342724.svg";